import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../Core/store';
import { axiosPrivate } from '../Core/axios';
import { ProjectCard } from '../Models/ProjectCard';
import { sliceStatus } from '../Helpers/types';
import { ProjectList } from '../Models/ProjectList';

export interface DashState {
  allProjectListsInRoadmap: Array<ProjectList>;
  allProjectCardsInRoadmap: Array<ProjectCard>;
  status: sliceStatus;
  errorMessage: string;
  dash: string;
  stage: string;
  showDashButtons: boolean;
  sort: string;
  sortDirection: string;
  selectedProjectId: string;
  fromDate: Date | null;
  toDate: Date | null;
}

const initialState: DashState = {
  allProjectListsInRoadmap: [], 
  allProjectCardsInRoadmap: [],
  status: "unset",
  errorMessage: "",
  dash: "workFunnel",
  stage: "",
  showDashButtons: true,
  sort: "",
  sortDirection: "",
  selectedProjectId: "",
  fromDate: null,
  toDate: null
};

export const getAllProjectListsForRoadmap = createAsyncThunk(
  'api/dash/get/lists',
  async (roadmapId: string) => {    
    return await axiosPrivate.get('api/dash/' + roadmapId + '/list',
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});

export const getAllProjectCardsForRoadmap = createAsyncThunk(
  'api/dash/get/cards',
  async (roadmapId: string) => {    
    return await axiosPrivate.get('api/dash/' + roadmapId + '/card',
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    ).then(
      (res) => {
        return res.data;
      }
    );
});

export const setDash = createAsyncThunk(
  'set-dash-dashboard',
  async (dash: string) => {    
      return dash;
});

export const setSort = createAsyncThunk(
  'set-dash-sort',
  async (sort: string) => {    
      return sort;
});

export const setSortDirection = createAsyncThunk(
  'set-dash-sort-direction',
  async (sortDirection: string) => {    
      return sortDirection;
});

export const setStage = createAsyncThunk(
  'set-dash-stage',
  async (stage: string) => {   
      return stage;
});

export const showDashButtons = createAsyncThunk(
  'set-dash-show-buttons',
  async (show: boolean) => {   
      return show;
});

export const setSelectedProjectId = createAsyncThunk(
  'set-dash-project',
  async (projectId: string) => {   
      return projectId;
});

export const setFromDate = createAsyncThunk(
  'set-dash-from-date',
  async (date: Date | null) => {   
      return date;
});

export const setToDate = createAsyncThunk(
  'set-dash-to-date',
  async (date: Date | null) => {   
      return date;
});

export const DashSlice = createSlice({
  name: 'dash',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProjectCardsForRoadmap.fulfilled, (state, action) => {
        state.allProjectCardsInRoadmap = action.payload;
      })
      .addCase(getAllProjectListsForRoadmap.fulfilled, (state, action) => {
        state.allProjectListsInRoadmap = action.payload;
      })
      .addCase(setDash.fulfilled, (state, action) => {
        state.dash = action.payload;
      })
      .addCase(setSort.fulfilled, (state, action) => {
        state.sort = action.payload;
      })
      .addCase(setSortDirection.fulfilled, (state, action) => {
        state.sortDirection = action.payload;
      })
      .addCase(setStage.fulfilled, (state, action) => {
        state.stage = action.payload;
      })
      .addCase(showDashButtons.fulfilled, (state, action) => {
        state.showDashButtons = action.payload;
      })
      .addCase(setSelectedProjectId.fulfilled, (state, action) => {
        state.selectedProjectId = action.payload;
      })
      .addCase(setFromDate.fulfilled, (state, action) => {
        state.fromDate = action.payload;
      })
      .addCase(setToDate.fulfilled, (state, action) => {
        state.toDate = action.payload;
      })
  },
});

export const getDash = (state: RootState) => state.dash;
export default DashSlice.reducer;
